import { combineReducers } from 'redux';
import { CHECKOUT_RT_STORE } from './rt/infra';

export const ORDER_STATE_NAME = 'order';

export const ORDER_REDUCERS = combineReducers({
  [CHECKOUT_RT_STORE.name]: CHECKOUT_RT_STORE.reducer,
});
